import { type SvgProps, SvgWrapper } from '../utils';

export function TrendingDownIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M21.25 10.9999C21.25 10.5857 21.5858 10.2499 22 10.2499C22.4142 10.2499 22.75 10.5857 22.75 10.9999V16.9999C22.75 17.4142 22.4142 17.7499 22 17.7499H16C15.5858 17.7499 15.25 17.4142 15.25 16.9999C15.25 16.5857 15.5858 16.2499 16 16.2499H21.25V10.9999Z" />
      <path d="M1.46973 6.46967C1.76262 6.17678 2.23738 6.17678 2.53028 6.46967L8.5 12.4394L12.9697 7.96967L13.0264 7.91791C13.321 7.6776 13.7557 7.69507 14.0303 7.96967L22.5303 16.4697C22.8232 16.7626 22.8232 17.2373 22.5303 17.5302C22.2374 17.8231 21.7626 17.8231 21.4697 17.5302L13.5 9.56049L9.03028 14.0302C8.73738 14.3231 8.26262 14.3231 7.96973 14.0302L1.46973 7.53022C1.17684 7.23732 1.17684 6.76256 1.46973 6.46967Z" />
    </SvgWrapper>
  );
}
